import { actionsLanguage as actions } from "./types";

export const setLanguage = (language: string) => {
    return {
        type: actions.SET_LANGUAGE,
        payload: language,
    };
};